<template>
  <section class="section section-shaped section-lg my-0">
    <div class="shape shape-style-1 bg-gradient-default">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container pt-lg-md">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <card type="secondary" shadow
                header-classes="bg-white pb-5"
                body-classes="px-lg-5 py-lg-5"
                class="border-0">
            <template>
              <div v-if="login_errado" class="alert alert-danger" role="alert">
                Número de inscrição ou CPF inválido.
              </div>
              <div class="text-muted text-center mb-3">
                <small>Entre com:</small>
              </div>
              <div class="btn-wrapper text-center">
              </div>
            </template>
            <template>
              <form @submit.prevent="envia_login" role="form">
                <base-input v-model="username" alternative
                            class="mb-3"
                            v-mask="'#######-#'"
                            placeholder="Número de inscrição"
                            addon-left-icon="ni ni-single-02">
                </base-input>
                <base-input v-mask="'###.###.###-##'" v-model="password" alternative

                            placeholder="CPF"
                            addon-left-icon="ni ni-badge">
                </base-input>

                <div class="text-center">
                  <base-button native-type="submit" type="primary" class="my-4">Entrar</base-button>
                </div>
              </form>
            </template>
          </card>
          <div class="row mt-3">
            <div class="col-6">
              <a href="#" class="text-light">
                <!--                <small>Esqueci minha senha</small>-->
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from 'axios';
import {useRouter} from 'vue-router';
import Vue from 'vue'
import vueCrypt from 'vue-crypt'
import {cpf} from "cpf-cnpj-validator";

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      login_errado: false,
      logins: [{cpf: 321., num_cand: 123}]
    }
  },
  methods: {
    envia_login: async function () {

      const encryptedText = this.CryptoJS.AES.encrypt("Hi There!", 'secret key 123').toString()
      const decryptedText = this.CryptoJS.AES.decrypt('U2FsdGVkX1+rGzJrqd1xvB4s0Sxxmcl9dbo4sUwcMsE=', 'secret key 123').toString(this.CryptoJS.enc.Utf8)

      const encrypt = (texto) => {
        return this.CryptoJS.AES.encrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString()
      }
      const decrypt = (texto) => {
        return this.CryptoJS.AES.decrypt(texto, 'yqKdRqWEAywufSJCZpvPUF5e929UKqMh5eh7AMP5Xpv2FrmdpFeSsnVkyTGvrhPRUG48tZtn32sEGz2R8tDrGcR6wTyYwhdCEvZxbdW42SYpKF7HvrW2XK6zjuWX9946tTx5RhycNDEW8uS475mRVNASZ4CW4v4RhBS5SYHCNHc6DjpwpzWcwuMvTQzCBzMtGbXF8ud4qXhcXnwAQ3xef2tQz3ZeBjvhu32zNGY5PXem92HX3MLRhuw78TqUVsUT').toString(this.CryptoJS.enc.Utf8);
      }

      const gera_file_name = (cpf, num_cand) => {

        let candidato = {CPF: cpf, NUMEROINSC: num_cand}
        let cod_projeto = '2106_pt'
        let codigo_meio = candidato.CPF.replace(/\./g, '').replace('-', '') * 7919;
        codigo_meio = codigo_meio.toString()

        let codigo_arquivo = parseInt(codigo_meio.substring(0, 5)) * parseInt(candidato.NUMEROINSC.replace('-', '')) * 13 + '_'
            + String.fromCharCode(65 + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[1]))
            + String.fromCharCode(parseInt(codigo_meio[4] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[7] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[7]))
            + '-'
            + String.fromCharCode(parseInt(codigo_meio[0] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[1] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))
            + String.fromCharCode(parseInt(codigo_meio[5] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[5]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[8]))
            + '_'
            + String.fromCharCode(parseInt(codigo_meio[2] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[3]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[4]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[6]))
            + String.fromCharCode(parseInt(codigo_meio[6] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[2]))
            + String.fromCharCode(parseInt(codigo_meio[3] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[11]))
            + String.fromCharCode(parseInt(codigo_meio[8] % 2 === 0 ? 97 : 67) + parseInt(codigo_meio[9]))

        return codigo_arquivo + '.pdf';
      }


      let cands = [
        {
          "num_cand": "U2FsdGVkX1/B14RUSrvUskVvxeSKPTYljQql0z+FB0Y=",
          "cpf": "U2FsdGVkX1/MkPIcSHz8NLwBE6E3xqRLzKkQCUXary4="
        }, {
          "num_cand": "U2FsdGVkX18Cql/FonaA19p43mqizdSuVDjhvYNaOX8=",
          "cpf": "U2FsdGVkX1/SNFlbxHbU7E2hqNidInzqG7eknV7tQls="
        }, {
          "num_cand": "U2FsdGVkX18GwIBfVPzlrOawjCGuLOtAVZ7AkhJil+s=",
          "cpf": "U2FsdGVkX1+imq+4/ntS8qXyTXhnoXeGsKoYyLPoTgA="
        }, {
          "num_cand": "U2FsdGVkX1/e87PaFKzc/bD2PpvvhXFTwdiH4hjjeiE=",
          "cpf": "U2FsdGVkX19q3B7570djC09uUoiYYn1UyIm9O+shIzg="
        }, {
          "num_cand": "U2FsdGVkX1/goENafJO5VMIrYPNdVas+vSreOJUG3+0=",
          "cpf": "U2FsdGVkX18ihx7q0PxVyW1FKj2VkR60jyTQtQqWxNw="
        }, {
          "num_cand": "U2FsdGVkX1/pBnugSUM77yka26jF6Etw/gDqeCowiDA=",
          "cpf": "U2FsdGVkX1++nz6NN37iB/Mwhl/TvNX4RtzIv3OGefQ="
        }, {
          "num_cand": "U2FsdGVkX1+VKgUwayiR8cI0kAG/KfaL/d8V9EGlal8=",
          "cpf": "U2FsdGVkX18Hk1henC5bIDmzZh/kzgtSp1XMJkT9CEw="
        }, {
          "num_cand": "U2FsdGVkX1+pw+tv5JUGTThKrJ/MJNzOl7+zEjnWiGk=",
          "cpf": "U2FsdGVkX19/U3pPQaw+OIYu4qG52YjcxCwqVmX14Dw="
        }, {
          "num_cand": "U2FsdGVkX19LIte7jR2H7tJgJCB7vuXSanAiZGWYLKM=",
          "cpf": "U2FsdGVkX1/i280MrIKGu/6U3Dl/uwuelJsng0xKGoY="
        }, {
          "num_cand": "U2FsdGVkX190DylHWFRh3c/Phckrk6MOtCjv4f2xTqs=",
          "cpf": "U2FsdGVkX1+llXaZVal1WMRp24hQ6Ktqa8V76nPk/OE="
        }, {
          "num_cand": "U2FsdGVkX18JQRxEEojODriVc/huMkrT+fsigsNg6rg=",
          "cpf": "U2FsdGVkX1+yOBpR+eEviCm9IpIEOXr/xfLas69w0b4="
        }, {
          "num_cand": "U2FsdGVkX19CsX5Nd1OEToUMaRPZkzVWyWfSIXw8068=",
          "cpf": "U2FsdGVkX1+s1C39qQV0jWXBVyjLOAqi1L+bihByC3g="
        }, {
          "num_cand": "U2FsdGVkX1/klfsQqkEPd4ZpeiprppPd7BchnukwzZA=",
          "cpf": "U2FsdGVkX18N9yK2xpi/le6fWPI51Z2NI1JU/uMeGkY="
        }, {
          "num_cand": "U2FsdGVkX1+LV9+5MjXjs6xwCBTBF6wKwsf5Jg4XDQ8=",
          "cpf": "U2FsdGVkX1+orF98byV4xWB4t04F6JeEg98TznhV0tQ="
        }, {
          "num_cand": "U2FsdGVkX18qOn2X/MsePAiVycwy8pCSDuh0hd9JJ6A=",
          "cpf": "U2FsdGVkX19s/Pu6Zn5iXiXnrZkHFWJodJnlCIqLQaE="
        }, {
          "num_cand": "U2FsdGVkX182vgQ0PZ1G6yu925CotOoxb9hc+/1ENv4=",
          "cpf": "U2FsdGVkX18kPFl+VFTCphBDvDKklN2aZjnHyMbmXwA="
        }, {
          "num_cand": "U2FsdGVkX1/fzQdARIECik3YWsTa7emlCRV51Ci+CRY=",
          "cpf": "U2FsdGVkX1+HwukM8W31/QDoc5H3bG9O4rjDNPmM2SU="
        }, {
          "num_cand": "U2FsdGVkX18PCMfT49qi50/9KiCGmXVr9wt7WaLtRWE=",
          "cpf": "U2FsdGVkX18kKOfsNPTjcLmlgLbD+AcqgY3WzzdShkM="
        }, {
          "num_cand": "U2FsdGVkX19bbDGI6+9xFOBv2oTXl3IVrO+LigxeB5M=",
          "cpf": "U2FsdGVkX18Bxi3Iw1hPqnexpi0U4AM4I05UcP0yBVU="
        }, {
          "num_cand": "U2FsdGVkX1+x6iNEADmwYAToCHbnrVdfA73vGs7jCoY=",
          "cpf": "U2FsdGVkX1+lthG6QgxJcT6oygd8jsBbcyG1SjOp3/k="
        }, {
          "num_cand": "U2FsdGVkX1/0iyOR72UryUsrbcu3byI5f1u8NT99yKA=",
          "cpf": "U2FsdGVkX1+eJaG5Jp9mxrOEriZ/23TQeWfJx8q6gVY="
        }, {
          "num_cand": "U2FsdGVkX1+k7ZDRmpUyoWyT7C8GnS/h5yPH5kfY6Aw=",
          "cpf": "U2FsdGVkX18LpBrg7ZnO1dkVqKpUT22F8/gJv4heNVY="
        }, {
          "num_cand": "U2FsdGVkX19k2ycyqj+ELoUCYPhXPwpVreZJ1x6EtWI=",
          "cpf": "U2FsdGVkX18PqdM9JKSWBCG1r4FUQrjFzH+jOdhHX/g="
        }, {
          "num_cand": "U2FsdGVkX1+e+m+cXkh81ucJ6i3Em4tEin598YUKGqM=",
          "cpf": "U2FsdGVkX1961v2ln/ora4kk0z+iJjZ6xv3TxF1lP0w="
        }, {
          "num_cand": "U2FsdGVkX1/8GuZAryVU5BefuwCilMinhLf+vgwtecU=",
          "cpf": "U2FsdGVkX19BkFjqYrtzTyW5ORFUGrkgi7riuoFpOgk="
        }, {
          "num_cand": "U2FsdGVkX18MPUjYwKLtB4NdRqkVrPW8LSr7JWCPcII=",
          "cpf": "U2FsdGVkX18sAzB/261a6TIPHYRVy3Gy9Zkq6OL/IYU="
        }, {
          "num_cand": "U2FsdGVkX1/E4B7jAvZ8ssTd7wZ1rfvVAwtU5FQt2Ag=",
          "cpf": "U2FsdGVkX18NvbOevG5eotk/k0Vy217Bbi5UgvsKmVU="
        }, {
          "num_cand": "U2FsdGVkX19RDtrMp/966i8qVDaeIygRTrYd1jt1BWg=",
          "cpf": "U2FsdGVkX1/z0Qi2v9xB2HQPQig+d6otSnUzArk6ye0="
        }, {
          "num_cand": "U2FsdGVkX19dqzsVkaIAeVi+fGe48t/KgguAwyXq06c=",
          "cpf": "U2FsdGVkX1+1cZGs38dr7svZJFqrfttDpel6EZleReM="
        }, {
          "num_cand": "U2FsdGVkX1/OEob6dLkobooyTvhIBu0jYYl7VCQVWnA=",
          "cpf": "U2FsdGVkX1+210MT4tR8YeRm+i9hgy2hYv5/w537k4k="
        }, {
          "num_cand": "U2FsdGVkX1+Q1lNNLkCwdi78h4ezwE4kofB+O2x87Ms=",
          "cpf": "U2FsdGVkX1+A5N4cVUJXRvShYdCphIhDGZFKn7VIS1M="
        }, {
          "num_cand": "U2FsdGVkX1/zAKZsZx0AQ1iNYBmqjFC5qoH5zcDte8Y=",
          "cpf": "U2FsdGVkX1+WuNa5Zn0AW1P7n5I8E541l6UrIEx+YEE="
        }, {
          "num_cand": "U2FsdGVkX1/IaY4gKjFC7sY50ce5fzr6QCM4TOgBQ14=",
          "cpf": "U2FsdGVkX1/r+xwsr6nS9ZA9dfWR/MMt4B1KverKN0I="
        }, {
          "num_cand": "U2FsdGVkX199sY1GCQIXnn9ioHgCCcxdY8ubAeqiq7c=",
          "cpf": "U2FsdGVkX1843LW52h0oZ30+4mULjSr5LIf5QdjPP9A="
        }, {
          "num_cand": "U2FsdGVkX19M8/w0KvWsYm4IySR3IW/4an1Gg1yyDFI=",
          "cpf": "U2FsdGVkX19HMud4CZPSC9YkJNtelqHgj1B/KiMzcdM="
        }, {
          "num_cand": "U2FsdGVkX1+KzRrpsqSXD2xd3UKpTQgW1Fbjv5eU+5U=",
          "cpf": "U2FsdGVkX18MyP+3UARKyy5A54t3g2sAtihqy332KzU="
        }, {
          "num_cand": "U2FsdGVkX1/zXCOHMAmQAaJARO5ZOCtq5+fImpDE5Z4=",
          "cpf": "U2FsdGVkX1+VJyjiDObQTHeGseiGRPKYw8G9nWGRXsY="
        }, {
          "num_cand": "U2FsdGVkX19jUxTPQKC7XuvQj+vDK1MtLyDqbxSYA9M=",
          "cpf": "U2FsdGVkX1/89ufR3iO04XmdQ1CQmQoEzKAOTvcXgYQ="
        }, {
          "num_cand": "U2FsdGVkX1+YC0fTwm3/pfO1eq6zfncgWn4Q6UuEHUY=",
          "cpf": "U2FsdGVkX1//cYKj2Wb+mH2BQIaBrcmvhTc8oDDYXck="
        }, {
          "num_cand": "U2FsdGVkX1+Y5PCqBn+nBrVQruf7wnwRPxxhnBmEKV0=",
          "cpf": "U2FsdGVkX19g3WxDStIuGiLBY4Alp3Du9WQLUEclkUc="
        }, {
          "num_cand": "U2FsdGVkX1/A8hohS2tafYpq3gkLQU8XkIWXMHbhilw=",
          "cpf": "U2FsdGVkX1+brRdPdd2RdFl3SzyXbRy9looYkctuJjs="
        }, {
          "num_cand": "U2FsdGVkX19nJCO5c1xk1GBwpiGhbrDLIFHltrHX41Q=",
          "cpf": "U2FsdGVkX18tPCD2n2itT1X/FpwfOrocrTV8U6JK/gE="
        }, {
          "num_cand": "U2FsdGVkX1+YjiCR00/0TY+WZdYJBp2BNlvUbkcr1+k=",
          "cpf": "U2FsdGVkX18uFvBN1FNqPxZbKfYYNT6FB3BjNP2/9zI="
        }, {
          "num_cand": "U2FsdGVkX1882VmEs5kzhjp5mCu1Ju6i4jAsBooBN2g=",
          "cpf": "U2FsdGVkX1+7hAwnIlPx07SOWut3YN7iQOZQ7l9zNGE="
        }, {
          "num_cand": "U2FsdGVkX19+TMut7vx/JS2r4RuVFPxPedvcNKvVx/A=",
          "cpf": "U2FsdGVkX18Sroo3A8daUZO7deMJEEzuB4Mghg8tkJE="
        }, {
          "num_cand": "U2FsdGVkX18szV9tgmp2HPbt46CNQYnRTx4ZPI0pvwQ=",
          "cpf": "U2FsdGVkX18n+if6UkGA17M29XzklJx4B9u70vciSjA="
        }, {
          "num_cand": "U2FsdGVkX18DwZH/BGtkrebMTYgaiANB4AbSsKkrKo8=",
          "cpf": "U2FsdGVkX18ThBfFEkmIJVK2i1rt/nFa5C5Q4m1CsNs="
        }, {
          "num_cand": "U2FsdGVkX18fs0tOZhZgVW3KIN9ht1GBZRxlstxoTkA=",
          "cpf": "U2FsdGVkX1+XopY4jxkMaILlj1rr2sNd0XfMsyPUlM4="
        }, {
          "num_cand": "U2FsdGVkX1/uUxqeWBlHVY543DcJgGEkDOzY5KMUHxQ=",
          "cpf": "U2FsdGVkX1/CLCa+wCmRpqxwuN0Q56PNhSR0NLgzm/U="
        }, {
          "num_cand": "U2FsdGVkX18ESZ3IUqpvzXNwVvDL7sLmeDYVXJg3JRk=",
          "cpf": "U2FsdGVkX1+Q3QqD5Db1Elm1cwVaXk0LwPLJaGRiBn8="
        }, {
          "num_cand": "U2FsdGVkX1+5S0MFHbcBv96P8H/7P7R5ZO/IZtb/zS4=",
          "cpf": "U2FsdGVkX1/ye8PsmTVZxm0llL41Fy9tfh325ue96aY="
        }, {
          "num_cand": "U2FsdGVkX19pH7Zq/aAa+1fJecdwfuAXSM28cc0qPvw=",
          "cpf": "U2FsdGVkX1/73Ocwg8ML2Al5EL9zkw/WKUxpXrx69O4="
        }, {
          "num_cand": "U2FsdGVkX1+n/4ZMNWPAvhTQakFB43l4g4ZkFGg6vhA=",
          "cpf": "U2FsdGVkX18LD1okSTVipUltDVKrAGUEj1cswezXyX0="
        }, {
          "num_cand": "U2FsdGVkX1/aL2ndLojFDugSnHdg+7H/X8DgmwyvLuI=",
          "cpf": "U2FsdGVkX1+4qMBa07TyGl6F26X7fMoqaBoEHem2aik="
        }, {
          "num_cand": "U2FsdGVkX1+TWNjZMv1s99PLXVGg8pnG0d8K1D03lDo=",
          "cpf": "U2FsdGVkX1/9GTQRlM5fWPbhZ/5+9KmM0AtwXMifwO0="
        }, {
          "num_cand": "U2FsdGVkX19YTYxugznsiWzh5c34exPuD8VHpbBV/yA=",
          "cpf": "U2FsdGVkX1/3xvoBZOnMNoXh6S6FFlHGbmhIjoX+knM="
        }, {
          "num_cand": "U2FsdGVkX19bfJscpSmAokRl7btGt6PGwXjQuO6hyoo=",
          "cpf": "U2FsdGVkX1/zIJ0MiCeg+3G2IEkaFXLB53zhGg2RitE="
        }, {
          "num_cand": "U2FsdGVkX19Drgy6T8Gl5y2R8gj8+V2RXCdJU9ms6X0=",
          "cpf": "U2FsdGVkX1+UtRwqRA+QX+3zallJUpMPPiGa4Z8q64M="
        }, {
          "num_cand": "U2FsdGVkX18uvFowkkKxYx+qOzyEBuzcH3uP/SJo7VA=",
          "cpf": "U2FsdGVkX19+GfSWXXhgfyY4KXhb52lO6L74TVEvAzQ="
        }, {
          "num_cand": "U2FsdGVkX18F3luF5nSY2BLGbOmno5Z3cWMvTeKnQPM=",
          "cpf": "U2FsdGVkX1/C9Afs+4xbKif4ziiP/xZDdHYh2zWtiMI="
        }, {
          "num_cand": "U2FsdGVkX1/xnfKh3rAj/SXjZmXUFGJcN+v4xq1RKmo=",
          "cpf": "U2FsdGVkX18CnhwHI+vgvNBB42sM/SXNVl1dzcBMJRk="
        }, {
          "num_cand": "U2FsdGVkX1+4nZ8+WetqNyCNUWGm7fPw5c7D4N1trA8=",
          "cpf": "U2FsdGVkX1+bD08KapgdqN6tdRioE+Dn90RiMfR3N6A="
        }, {
          "num_cand": "U2FsdGVkX1/ZXWXoxlRChQjHZENjhiRhYy+zJ83WweU=",
          "cpf": "U2FsdGVkX1+OZMHo6PHabG6b8C1q0wN+TZtEdXleDuM="
        }, {
          "num_cand": "U2FsdGVkX1/zYD3pvtFoLzjpMdJyQ0BV53KijPaik/4=",
          "cpf": "U2FsdGVkX1+/Gn2VwwSx4zG5oUZUjG5vUpT+KdCgyo0="
        }, {
          "num_cand": "U2FsdGVkX18ejKqdR7Zb1BMzCoY2eGSljDjE2kL9Heg=",
          "cpf": "U2FsdGVkX19Nee+KCAJ6lLEbu0Hkck+Tv0Mh6tv7BnI="
        }, {
          "num_cand": "U2FsdGVkX183SQ3RKy89avKfCjF0hFMwdUHx4LgfLRI=",
          "cpf": "U2FsdGVkX1/79JNmlGqlZ2zE6vS+feQ3EZ/822+xJ50="
        }, {
          "num_cand": "U2FsdGVkX19/U6YhHgUPHGxrw41Dfzl0lBMuP4uRvp0=",
          "cpf": "U2FsdGVkX19n8jvkTfiWCvmDaJLAPmLwXKExMEHBkjI="
        }, {
          "num_cand": "U2FsdGVkX18Nwh9Hn/+3kO6g351L7a5xjgWbPM+2/gM=",
          "cpf": "U2FsdGVkX1+0/T+wbRw56se3/+aXDAYJCVtzfRTPI4M="
        }, {
          "num_cand": "U2FsdGVkX1/uzubiDG/K10h5edTGNAYvaFBnM4dXNrQ=",
          "cpf": "U2FsdGVkX1+aHu1SP+OmbfHdwzR0axT0EoXEDZkRAVo="
        }, {
          "num_cand": "U2FsdGVkX19kxMMrDiQLqAi0P3n03wFsq5V0DHBweqY=",
          "cpf": "U2FsdGVkX1/P4uSs7yEXLGoQEyKSdspzO8vcy49OD8A="
        }, {
          "num_cand": "U2FsdGVkX1/1HxaXS5FkkRwsXUlP/OPnZmla92NxFic=",
          "cpf": "U2FsdGVkX1/nPIacNFpKdlFflnCQypaVf3nrcLNlzBE="
        }, {
          "num_cand": "U2FsdGVkX19SOAXKswv26bHPw7rFIAdP13T0va+ivTI=",
          "cpf": "U2FsdGVkX19Dom6NwVltqicthFJZJbl4x1h78cof7Ik="
        }, {
          "num_cand": "U2FsdGVkX1+gbd7CqOcoTjzaG6Kpc89JHSMww2FBy60=",
          "cpf": "U2FsdGVkX18uGNah0d6SwkbKUs4QxraKn7O506tF0kE="
        }, {
          "num_cand": "U2FsdGVkX18bZ7NEoNc3YBX6ZaK0zB6LTtjiJI9AOyI=",
          "cpf": "U2FsdGVkX19LmJKLF0txrw55vWEByJejfHoCZCKW/0E="
        }, {
          "num_cand": "U2FsdGVkX1/CM0URptB+efVAhCXzR+PfoZWo+dMjyWc=",
          "cpf": "U2FsdGVkX1+yjVNkZzPJLzJhB3X4qLaIdO6fwBTwcvI="
        }, {
          "num_cand": "U2FsdGVkX1+tm04P2NTuU+Qna79CV9T6cN/sEon40GQ=",
          "cpf": "U2FsdGVkX18DLcamib28r5B8xM2t0dMvQ8SYXFFTc+Q="
        }, {
          "num_cand": "U2FsdGVkX1/+6oiTo8hCWqditUYTegwtlOO69VnEheo=",
          "cpf": "U2FsdGVkX1+R30oFEtD63lWJkxT7BgREO4hz+f4K6JE="
        }, {
          "num_cand": "U2FsdGVkX186obe3jgLSK3FwjfkYpeFvTSW7I0Tpeko=",
          "cpf": "U2FsdGVkX18OnqdlbsW7GCiYvjQ2rVk9URAwdi3M0Q4="
        }, {
          "num_cand": "U2FsdGVkX1/0CW2J2x9a6Y/yWou1STwTmFxLndmX6l4=",
          "cpf": "U2FsdGVkX1+5b9IxqHtV/p83OkRQw/ln1/1PmeyUQZU="
        }, {
          "num_cand": "U2FsdGVkX1/uNXCmzehi9vDNkczHm/nZoJeJvgTXGcw=",
          "cpf": "U2FsdGVkX18hZsriTDS6ev2Eels2/ThGLDpsV/vYxuI="
        }, {
          "num_cand": "U2FsdGVkX19b25uoOseMMUsJPVS9eQmln5goOLIm7n0=",
          "cpf": "U2FsdGVkX18hinQOhXw4EVvidEYb/2C4tdVGHkCUJRw="
        }, {
          "num_cand": "U2FsdGVkX18UPu0bTnPz8Ee08dMtF+s5zXuHs8KpiCM=",
          "cpf": "U2FsdGVkX1/LfD2WaoNHzMy0lRvIBMtsft68GUjf4Kg="
        }, {
          "num_cand": "U2FsdGVkX19WgClnRoxJHShNgII/JLtNQxpsAOoChK4=",
          "cpf": "U2FsdGVkX1/6O7L9ffZaN059ygVCAvBsvD+oKAjOlsI="
        }, {
          "num_cand": "U2FsdGVkX19GudbbV9Y8uP7cPzF0WHxo2oXUwZVdsYc=",
          "cpf": "U2FsdGVkX19+fISyh8oMKmR4Au3OSIi3fcRAWTq9O+Q="
        }, {
          "num_cand": "U2FsdGVkX1/WBy39BLlbEyA7i1W8UtzUgKuml7VSRdw=",
          "cpf": "U2FsdGVkX1+JA2RJWd25yOoREt1aRcLQf3iHUI6FOgI="
        }, {
          "num_cand": "U2FsdGVkX1+/dswB0Yi5B4z5A/wLGTFxpeQpjKQ+vN8=",
          "cpf": "U2FsdGVkX18avVXG6lnHTKZ6yoKAatyIBZYSEn4CBek="
        }, {
          "num_cand": "U2FsdGVkX1+JzV96cbtOrGeQxnuSoQctMGH93IUvjIg=",
          "cpf": "U2FsdGVkX19E3EkgJWC+KvwWBOihWwO2SqiRbtm21Fk="
        }, {
          "num_cand": "U2FsdGVkX1/w5K6IryBHSeTkF0c3XB6XIPSTyL7WGbc=",
          "cpf": "U2FsdGVkX19ROxKk3hsjEKQJILowK8gXqoTnHdVcuAw="
        }, {
          "num_cand": "U2FsdGVkX1/XXy/4kZljxxRzqLpOCQRlDSdiJCA4OHQ=",
          "cpf": "U2FsdGVkX180DJWW5pG9QY80der28sFTvPBPuEci2qo="
        }, {
          "num_cand": "U2FsdGVkX1/CfzzUDtTM1Z3AmEzz9R9XD1aWSSY+y3w=",
          "cpf": "U2FsdGVkX18jNDhGrleDwNNpMEC4LnW/ZEl38XZDdvg="
        }, {
          "num_cand": "U2FsdGVkX1/xqgZigZFKQYPdezimMUDJYdseNGgmHI8=",
          "cpf": "U2FsdGVkX19OFbBuaafFfkyzRZRI8ZKD9Fr4JNw5eFE="
        }, {
          "num_cand": "U2FsdGVkX1/hK18PuKcoy+CymrJt8EZmAGcT4/UEqgM=",
          "cpf": "U2FsdGVkX1+nek3Rl9ynRufx8s99yUKw3o/3gUE+JVI="
        }, {
          "num_cand": "U2FsdGVkX19XXJRfWsJk5L5vf5hNWxIh5BDq8eFYxY0=",
          "cpf": "U2FsdGVkX19gI8Se+HtMIiaUqPiJ/GlUIVPNfPKH980="
        }]


      try {
        let concurso = this.$route.params.concurso;
        localStorage.setItem('concurso', concurso);

        for (let login of cands) {
          let num_cand_decripted = decrypt(login.num_cand);
          let cpf_decripted = decrypt(login.cpf);

          // console.log(num_cand_decripted,cpf_decripted)
          if (num_cand_decripted == this.username && cpf_decripted == this.password) {
            console.log(`Logged`)
            let nome_arquivo = (gera_file_name(cpf_decripted, num_cand_decripted))
            nome_arquivo = nome_arquivo.replace(/\x00/g, '-');


            // alert(`Logou`);
            let url = (`https://fs.ibfc.org.br/arquivos/2203/2203_re_po/${nome_arquivo}`)
            return window.location = url;
          }
        }

        throw new Error(`Login inválido`);


      } catch (error) {
        console.log(error);
        this.login_errado = true;
      }
    }
  }
};
</script>
<style>
</style>
